import React, { useState, useEffect } from "react";
import "../AddEditManualModal/AddEditManualModal.css";
import { useLanguage } from "../../../../LanguageProvider";
import DatePicker from "../../../../components/DatePicker/DatePicker";
import TimePicker from "../../../../components/TimePicker/TimePicker";
import { useToaster } from "../../../../ToasterProvider";

const EditStartModal = ({ isOpen, onClose, onSave, activeKronosData }) => {
  const { getTranslation } = useLanguage();
  const { toastWarning } = useToaster();
  const [startDate, setStartDate] = useState("");
  const [startTime, setStartTime] = useState("");

  useEffect(() => {
    if (activeKronosData && activeKronosData.startDateTime) {
      const date = new Date(
        parseInt(activeKronosData.startDateTime, 10) * 1000
      ); // Timestamp to Date
      setStartDate(date.toISOString().split("T")[0]); // YYYY-MM-DD formatı
      setStartTime(
        date.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
      ); // Saat formatı (09:34 AM)
    }
  }, [activeKronosData]);

  const handleSave = () => {
    if (!startDate || !startTime) {
      toastWarning(getTranslation("pleaseFillAllFields"));
      return;
    }

    const formatDateTime = (date, time) => {
      const localDate = new Date(date);
      localDate.setMinutes(
        localDate.getMinutes() - localDate.getTimezoneOffset()
      ); // Zaman dilimi farkını düzelt

      const formattedDate = localDate.toISOString().split("T")[0];

      const [timePart, meridian] = time.split(" ");
      let [hours, minutes] = timePart.split(":");

      if (meridian === "PM" && hours !== "12") hours = parseInt(hours, 10) + 12;
      if (meridian === "AM" && hours === "12") hours = "00";

      return `${formattedDate}T${String(hours).padStart(2, "0")}:${minutes}`;
    };

    const startDateTime = formatDateTime(startDate, startTime);

    onSave(startDateTime);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="add-manual-modal-overlay">
      <div className="add-manual-modal">
        <span className="add-manual-modal-title">
          {getTranslation("editStartTime")}
        </span>

        <span className="add-manual-modal-subtitle">
          {getTranslation("startDate")}
        </span>
        <div style={{ display: "flex", gap: "10px" }}>
          <DatePicker
            style={{ width: "100%" }}
            buttonStyle={{ width: "100%" }}
            onDateSelect={(date) => setStartDate(date)}
            toggleLabel={getTranslation("startDate")}
            initialDate={startDate} // Başlangıç değeri
          />
        </div>

        <span className="add-manual-modal-subtitle">
          {getTranslation("startTime")}
        </span>
        <div style={{ display: "flex", gap: "10px" }}>
          <TimePicker
            style={{ width: "100%" }}
            buttonStyle={{ width: "100%" }}
            onTimeSelect={(time) => setStartTime(time)}
            toggleLabel={getTranslation("startTime")}
            initialTime={startTime} // Başlangıç değeri
          />
        </div>

        <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
          <button className="add-manual-modal-cancel-button" onClick={onClose}>
            {getTranslation("close")}
          </button>
          <button className="add-manual-modal-add-button" onClick={handleSave}>
            {getTranslation("save")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditStartModal;
